const examRanges = { min: 30, max: 100 }
const annualRanges = { min: 4, max: 10 }


export const isValidGradeValue = ({ subjectId, gradeType, value, level }) => {
    value = parseInt(value);

    console.log('isValidGradeValue', {
        subjectId,
        gradeType,
        value,
        level,
    });

    if (!value) {
        return true;
    }

    const range = gradeType === 'exam' ? examRanges : annualRanges;

    // dropdown
    if (!level) {
        return true;
    }

    if (!range) {
        console.log(`unhandled validation level: ${level}`);
        return true;
    }

    if (value >= range.min && value <= range.max) {
        return true;
    }

    // console.log({ subjectId, gradeType, value, level })
};
